import { defineMessages } from 'react-intl';

const messages = defineMessages({
    externalUser: {
        defaultMessage: 'External user',
        description: 'Text for an icon aria label to convey an external user of the enterprise',
        id: 'boxui.avatar.externalUser',
    },
});

export default messages;
